<template>
  <!-- 后台管理系统主界面 -->
  <div class="wrapper" :class="isdate ? 'data' : ''">
    <el-container>
     
      <el-header>
        <!-- 头 -->
        <!-- 判断在移动端上-->
        <div v-if="screenWidth <= 768" style="text-align: left">
          <el-button icon="el-icon-s-unfold" @click="show()"></el-button>
        </div>
        <div
          style="position: absolute; padding-left: 20px"
          v-if="screenWidth > 768"
        >
          <img
            @click="handleClickImg"
            style="width: 40px; height: 40px; vertical-align: middle;"
            src="../images/mengzhengfile.png"
            alt="系统logo"
          />
          <span style="color: #fff">蒙正后台管理系统</span>

          <span class="wiki" v-if="isWiki" @click="handleClickWiki">Wiki</span>
        </div>

        <div style="width: 200px; position: absolute;  right: 250px; color: #fff; " >
          城市：{{ this.cityvalue === '1' ? '北京' : this.cityvalue==='2' ?'深圳': this.cityvalue === '3' ? '上海' : this.cityvalue === '1,2' ? '北京、深圳' : this.cityvalue === '1,3' ? '北京、上海' : this.cityvalue === '2,3' ? '深圳、上海' : this.cityvalue === '1,2,3' ?  '北京、深圳、上海' : '暂无权限' }}
          <!-- <el-select v-model="cityvalue" placeholder="请选择" style="width: 100px;">
            <el-option
              v-for="item in optionsListt"
              :key="item.id"
              :label="item.dictValue"
              :value="item.dictType">
            </el-option>
          </el-select> -->
        </div>

        <div style=" text-align: right;  position: absolute;  right: 90px;  padding-left: 10px;  display: flex;  top: 15px;   color: #fff;  font-size: 35px;  width: 150px;" @click="handleClickTop">
            <i class="el-icon-chat-dot-round"></i>
            <div style="
              background: #e41b1b;
              height: 20px;
              width: 20px;
              border-radius: 50%;position: absolute;  right: 111px; display: flex;">
              <span style="position: absolute;  right: 5px; display: flex; top: -20px; font-weight: 900; color: #fff" :style="{ fontSize: messageNmu >= 10 ? '9px' : '15px',  }"> {{ messageNmu ? messageNmu : 0 }}</span>
            </div>
        </div>

        <div style="text-align: end;">
          <!-- 系统标题 -->
          <!-- <img
            :src="initName"
            style="width: 30px; height: 30px; vertical-align: middle"
            alt="默认用户头像"
          /> -->
          <el-dropdown @command="handleCommand">
            <div style="
              text-align: right;
              background: #ce966b;
              right: 18px;
              padding-left: 10px;
              display: flex;
              width: 166px;
              color: #fff;
            ">
          <viewer :images="photo">
            <img  style="position: absolute; margin-top: 15px; width: 30px; height: 30px;" v-for="(src, index) in photo" :src="src"  :key="index"  />
          </viewer>

          <span style="font-size: 14px;margin-left: 36px;color: #fff;">您好，{{ name }}</span>
          <!-- <el-dropdown @command="handleCommand"> -->
            <i class="el-icon-caret-bottom" style="margin-right: 15px"></i>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="center">个人中心</el-dropdown-item> -->
              <!-- <el-dropdown-item command="updatePassword"
                >修改密码</el-dropdown-item
              > -->
              <el-dropdown-item command="exit" style="width: 110px;"
                >退出</el-dropdown-item
              >
            </el-dropdown-menu>
          </div>
          </el-dropdown>
        </div>
      </el-header>
    
      <el-container>
        <el-aside width="220px" style="height: 90vh; overflow-y: scroll;" v-if="show_nav"  :class="showclass">
          <left-menu @handleClickRouter="handleClickRouter" />
        </el-aside>

        <el-main style="height: 100%;">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="background: #fffdfd; padding-bottom: 20px; padding-top: 10px">
            <el-breadcrumb-item v-for="(itme,index) in itmeBreadList" :key="index">
              {{ itme.jurTitle }}
            </el-breadcrumb-item>
          </el-breadcrumb>
          <router-view></router-view>
        </el-main>
      </el-container>
      
    </el-container>
    
    <el-container>  
     <el-footer style="width: 100%; bottom: -9px;">
       <div style="left: 50%; ">
         <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024079750号-2</a>
       </div>
     </el-footer>
    </el-container>
    

    <message v-if="showComponents" @handleEventBts="handleEventBts" :records="records" @handleEvent="handleEvent"></message>

  </div>
</template>

<script>
// import LeftMenu from './menu.vue'
import LeftMenu from "../manager/layout/menu.vue";
import { isDate } from '../utils/date'
import axios from "axios";
import apiBaseUrl from "../../config/api";
import message from "../newsMessage-components/message.vue";
import { getSubject } from "@/api/fiveClassApi"
export default {
  name: "ManagerMain",
  components: {
    LeftMenu,
    message
  },
  data() {
    return {
      isWiki: false,
      records:[],
      messageNmu: 0,
      showComponents:false,
      photo:[],
      initName:'',
      isdate:'',
      showclass: 'asideshow',
      itmeBreadList: [
        { jurTitle: "客资管理"},
        { jurTitle: "查看客资"},
      ],
      itmeBread: { item: {} },
      // flag: false, //隐藏标志
      show_nav: true, //1
      time: "",
      screenWidth: document.documentElement.clientWidth, //1
      default_active: "0",
      name: "",
      menuList: JSON.parse(window.localStorage.getItem("jur")),
      // optionsListt:[
      //   {dictValue:"北京", dictType:1 },
      //   {dictValue:"深圳", dictType:2 },
      // ],
      cityvalue:'',
    };
  },
  // computed: {
  //   // isTeacher: () => {
  //   //   return window.localStorage.getItem("teacher") != null;
  //   // }

  // },
  // created() {
  //   const jur = JSON.parse(window.localStorage.getItem("jur"));
  //   if (Array.isArray(jur) && jur.every(item => item.hasOwnProperty('jurId') && item.hasOwnProperty('jurUrl') && item.hasOwnProperty('jurIcon'))) {
  //     this.menuList = jur;
  //
  //     // 设置defaultActive为menuList中的第一个jurId
  //     this.defaultActive = this.menuList[0].jurId;
  //   } else {
  //     console.error('数据格式错误！');
  //   }
  // },
  // created(){
  //   this.$router.push('/customermange')
  // },
  created() {
    this.menuList = JSON.parse(window.localStorage.getItem("jur"));


    setTimeout(() => {
      this.cityvalue = window.localStorage.getItem('cityTepy')

    },1000)

    //
    // const defaultHref = this.menuList[0].children
    //   ? this.defaultActive(this.menuList[0].children)
    //   : this.menuList[0];
    //   if (this.$route.path !== defaultHref.jurUrl) {
    //   this.$router.replace({
    //     path: defaultHref.jurUrl
    //   });
    // }


  },
  mounted() {
    axios.get(`${apiBaseUrl}/dict/getDictionary/${'岗位'}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if(res.data.code === 200){
        sessionStorage.setItem('positionList',JSON.stringify(res.data.data))
      }else{
        sessionStorage.setItem('positionList',JSON.stringify([]))
      }
    }).catch(error => {
      sessionStorage.setItem('positionList',JSON.stringify([]))
    })

    axios.get(`${apiBaseUrl}/courseManage/getSubjectPermissions`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if(res.data.code === 200){
        sessionStorage.setItem('getSubjectPermissions', res.data.data ? 'Y' : 'S')
      }
    }).catch(error => {
      this.$message({ message:res.data.message ? res.data.message : res.data.meg,  type: "error"   });
    })


    // 规划师下拉接口
    axios.get(`${apiBaseUrl}/projectTeacher/findList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if(res.data.code === 200){
        sessionStorage.setItem('projectTeacherFindList',JSON.stringify(res.data.data))
      }else{
        sessionStorage.setItem('projectTeacherFindList',JSON.stringify([]))
      }
    }).catch(error => {
      this.$message({ message:res.data.message ? res.data.message : res.data.meg,  type: "error"   });
    })

    // 诊断师下拉接口
    axios.get(`${apiBaseUrl}/diagnoseTeacher/findList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if(res.data.code === 200){
        sessionStorage.setItem('diagnoseTeacherFindList',JSON.stringify(res.data.data))
      }else{
        sessionStorage.setItem('diagnoseTeacherFindList',JSON.stringify([]))
      }
    }).catch(error => {
       this.$message({ message:res.data.message ? res.data.message : res.data.meg,  type: "error"   });
    })


    axios.get(`${apiBaseUrl}/courseManage/getSubjectList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if(res.data.code === 200){
        let data = res.data.data.map(fore => {
          fore.teacherId = fore.categoryIds
          fore.teacherName = fore.subjectGroupName
          return  fore
        })
        sessionStorage.setItem('SubjectGroupList',JSON.stringify(res.data.data))
      }else{
        sessionStorage.setItem('SubjectGroupList',JSON.stringify([]))
      }
    }).catch(error => {
       this.$message({ message:res.data.message ? res.data.message : res.data.meg,  type: "error"   });
    })



    this.scheduleMidnightRefresh();

    axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
              this.messageNmu = res.data.data.total ? res.data.data.total : 0
              if(res.data.data.records.length > 0){
                this.records = res.data.data.records
              }else{
                this.records = []
              }
          } else {
              // this.$message({  message: res.data.message,   type: "error"})
          }
        }).catch(err => {
          //  this.$message({  message: err,   type: "error"})
    })


    

    axios.post(`${apiBaseUrl}/dict/getDictList`, { pageNo:1, pageSize:100, dictCode:"收款渠道" },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
      if (res.data.code == 200) {
         let datas = res.data.data.records.map(fore => {
            fore.value = fore.dictType
            fore.label = fore.dictValue
            return fore
         })
         sessionStorage.setItem('payTypesList',JSON.stringify(datas))
      }
    })


    axios.get(`${apiBaseUrl}/sale/getSaleList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
      if (res.data.code == 200) {
         let datas = res.data.data.map(fore => {
            fore.id = fore.telephone
            fore.saleId = fore.saleId
            fore.label = fore.saleName 
            return fore
         })
         sessionStorage.setItem('customersaleObj',JSON.stringify(datas))
      }
    })  

    axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
      if(res.data.code === 200){
        let getOrgTreeList =  res.data.data
        sessionStorage.setItem('getOrgTreeList',JSON.stringify(getOrgTreeList))
      }else{
        sessionStorage.setItem('getOrgTreeList',JSON.stringify([]))
      }
    })

    getSubject().then(res => { 
      if(res.code === 200){
        let categoryIdsList = res.data
        sessionStorage.setItem('categoryIdsList',JSON.stringify(categoryIdsList))
      }else{
        sessionStorage.setItem('categoryIdsList',JSON.stringify([]))
      }
    })

   
    this.handleMessges()

    this.isdate =  isDate()

    //
    //1
    window.addEventListener("resize", this.updateScreenWidth);

    setInterval(() => {
      this.getTime();
    }, 1000);

    let admin = window.localStorage.getItem("admin");


    //
    if (admin != null) {
        this.name = JSON.parse(admin).realname;
        this.initName = this.name === 'tamariscina Selaginella'  ? 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/1740711399467_4eead5fe.jpg' : this.name ==='李开心' ? 'https://img2.woyaogexing.com/2021/08/30/bfe0743d022246449bceabdbdcbb609f%21400x400.jpeg' : 'http://mz-app-develop.oss-cn-beijing.aliyuncs.com/mz_pc/default.png'
        this.photo = [this.initName]
    } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          this.name = JSON.parse(teacher).realname;
        }
    }
    if (this.screenWidth <= 768) {
        this.show_nav = false;
    } else {
        this.show_nav = true;
    }


    let jurList = JSON.parse(localStorage.getItem("jur"))
    jurList.map(item => {
      if(item.jurTitle === 'Wiki'){
         this.isWiki = true
      }
    })

  },

  //1
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {

    handleClickWiki(){
      this.$router.push("/CKEditor")
    },


    // 强制刷新页面
    scheduleMidnightRefresh() {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0); // 次日凌晨 00:00:00
      const timeUntilMidnight = midnight - now; // 距离午夜的毫秒数

      // 设置定时器在午夜刷新页面
      setTimeout(() => {
        this.refreshPage();
        // 每天午夜后再次设置定时器
        setInterval(this.refreshPage, 24 * 60 * 60 * 1000); // 每隔24小时刷新一次
      }, timeUntilMidnight);
    },

    refreshPage() {
      // 刷新页面或重新拉取数据
      location.reload(); // 刷新整个页面
      // 或者调用接口重新加载数据
      // this.getDataFromServer();
    },




    handleEvent(e){
      this.messageNmu = e
    },

    handleMessges(){
    setInterval(()=>{
        axios.post(`${apiBaseUrl}/information/findList`, { pageNum:1, pageSize: 100000 },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
              this.messageNmu = res.data.data.total ? res.data.data.total : 0
              if(res.data.data.records.length > 0){
                this.records = res.data.data.records
              }else{
                this.records = []
              }
          } else {
              // this.$message({  message: res.data.message,   type: "error"})
          }
        }).catch(err => {
          //  this.$message({  message: err,   type: "error"})
        })
    },10000)
    },

    handleClickTop(){
      this.showComponents = true
    },
    handleEventBts(){
      this.showComponents = false
    },

    handleClickImg(){
      this.$router.push("/model");
    },
    handleClickRouter(a,b,c){
      this.itmeBreadList = []
      let P = { jurTitle: a }
      let C = { jurTitle: b }
      this.itmeBreadList.push(P)
      this.itmeBreadList.push(C)
    },
    handleLeftMenu(item) {
      if (item) {

        this.itmeBread = item;
      }
      if (item.item.jurUrl) {
        this.$router.push({
          path: item.item.jurUrl,
          query: {
            activeName: item.item.activeName,
            names: item.item.names,
            type: item.item.type,
          },
        });
        /*兄弟页面可通过触发,bus方法需要另外安装依赖
                this.$bus.$on('changeLeftMenu', item => {
                this.activeName = item.activeName
                this.names = item.names
                this.updateVal()//接口
            })
                */
        //
        this.$emit("changeLeftMenu", item);
      }
    },
    // defaultActive(list) {
    //   if (list[0].children) {
    //     return this.defaultActive(list[0].children);
    //   } else {
    //     return list[0];
    //   }
    // },
    generateMenuItems(h, menuItems) {

      return menuItems.map((item) => {
        if (item.children != null && item.children.length > 0) {


          return h("el-submenu", { attrs: { index: item.jurId } }, [
            h("template", { slot: "title" }, [
              h("i", { class: item.jurIcon }),
              item.jurTitle,
            ]),
            // this.generateMenuItems(h, item.children)
          ]);
        } else {

          // return h('el-menu-item', { attrs: { index: String(item.jurId) } }, [
          //   h('router-link', { attrs: { to: item.jurUrl }, class: 'links' }, [
          //     h('i', { class: item.jurIcon }),
          //     item.jurTitle
          //   ])
          // ]);
        }
      });
    },
    //1
    updateScreenWidth() {
      this.screenWidth = document.documentElement.clientWidth;
      if (this.screenWidth <= 768) {
        this.show_nav = false;
      } else {
        this.show_nav = true;
      }
    },
    // 下拉菜单功能，退出、个人中心
    handleCommand(command) {
      // alert(command)
      if (command == "exit") {
        sessionStorage.removeItem("tokenInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("admin");
        localStorage.removeItem("teacher");
        localStorage.removeItem("cityTepy");
        // 判断，返回指定页面
        this.$router.push("/");
      } else if (command == "center") {
        // 跳转到个人中心
      } else if (command == "updatePassword") {
        // 修改密码页面
        this.$router.push("/updatepass");
      }
    },
    //1
    show() {
      if (this.show_nav) {
        this.show_nav = false;
      } else {
        this.show_nav = true;
      }
    },

    // 获取系统时间
    getTime() {
      this.time = new Date().toLocaleString();
    },

    // 展开一个菜单
    handleSelect(val) {
      this.default_active = val;
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  height: 100%;
  width: 100%;

  .a {
    text-decoration: none !important;
    color: #303133 !important;
  }

  .links {
    text-decoration: none !important;
    color: #303133 !important;
  }
}

.el-container {
  height: 95%;
  padding: 0;
  margin: 0;
  width: 100%;
}

.el-header,
.el-footer {
  position: relative;
  // background-color: #b3c0d1;
  background-color: #ce966b;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  position: sticky;
  top: 0;
  z-index: 999;
  // background-color: #d3dce6;
  color: #333;
  text-align: center;
  line-height: 200px;
  overflow: hidden;
}

.el-icon-caret-bottom{
  padding-left: 15px;
  padding-top: 22px;
}

.el-main {
  background-color: #fff;
  color: #333;
  text-align: center;
  padding: 10px;
  overflow: auto;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

// .el-header{
//   display: flex;
//   justify-content: space-between;
// }
@media screen and (max-width: 750px) {
  // #app {
  //   width: 1920px;
  // }
  .el-header {
    display: flex;
    justify-content: space-between;
  }
}

.data{
  pointer-events: none;
}

.wiki{
    color: rgb(34 165 57);
    font-size: 13px;
    font-weight: 900;
    margin-left: 22px;
    background: #eff0f1;
    height: 38px;
    width: 37px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 10px;
    left: 178px;
    line-height: 38px;
    padding: 0px 1px;
}



</style>



// WEBPACK FOOTER //
// src/manager/ManagerMain.vue